import { gql } from '@apollo/client';

export const VULNERABILITY = gql`
  query vulnerability($args: VulnerabilityInput!) {
    vulnerability(args: $args) {
      id
      createdDatetime
      processedDatetime
      description
      nvdStatus
      problemTypes {
        value
        name
        url
        __typename
      }
      exploit {
        ransomwareDatetime
        recentRansomwareDatetime
        maturity
        epss {
          score
          percentile
        }
        references {
          exploits {
            url
            name
            refsource
            dateAdded
            exploitMaturity
            exploitAvailability
          }
          botnets {
            botnetName
            dateAdded
          }
          threatActors {
            name
            aliases
            url
          }
          ransomware {
            families
            references {
              date
              url
            }
          }
          knownExploitedVulnerabilities {
            action
            dateAdded
            dueDate
            name
          }
          knownAttacks {
            name
            displayName
            associatedVulnerabilitiesList
          }
        }
      }
      references {
        url
        name
        refsource
      }
      impactV31 {
        metric {
          type
          source
          impactScore
          exploitabilityScore
          cvssData {
            version
            vectorString
            attackVector
            attackComplexity
            privilegesRequired
            userInteraction
            scope
            confidentialityImpact
            integrityImpact
            availabilityImpact
            baseScore
            baseSeverity
            temporalScore
            environmentalScore
          }
        }
      }
      impactV4 {
        source
        type
        threatCvssSecondary {
          exploitMaturity
          baseThreatSeverity
          baseThreatScore
          associatedBaseMetricV40 {
            source
            type
            baseScore
          }
        }
        cvssData {
          version
          vectorString
          baseScore
          baseSeverity
          attackVector
          attackComplexity
          attackRequirements
          privilegesRequired
          userInteraction
          vulnConfidentialityImpact
          vulnIntegrityImpact
          vulnAvailabilityImpact
          subConfidentialityImpact
          subIntegrityImpact
          subAvailabilityImpact
          exploitMaturity
          confidentialityRequirement
          integrityRequirement
          availabilityRequirement
          modifiedAttackVector
          modifiedAttackComplexity
          modifiedAttackRequirements
          modifiedPrivilegesRequired
          modifiedUserInteraction
          modifiedVulnConfidentialityImpact
          modifiedVulnIntegrityImpact
          modifiedVulnAvailabilityImpact
          modifiedSubConfidentialityImpact
          modifiedSubIntegrityImpact
          modifiedSubAvailabilityImpact
          safety
          automatable
          recovery
          valueDensity
          vulnerabilityResponseEffort
          providerUrgency
        }
      }
      impact {
        base {
          vectorString
          attackVector
          attackComplexity
          privilegesRequired
          userInteraction
          scope
          confidentialityImpact
          integrityImpact
          availabilityImpact
          baseScore
          baseSeverity
          impactScore
          exploitabilityScore
        }
      }
      impactV2 {
        base {
          version
          vectorString
          accessVector
          accessComplexity
          authentication
          integrityImpact
          confidentialityImpact
          availabilityImpact
          baseScore
          impactScore
          exploitabilityScore
          severity
        }
      }
    }
  }
`;

export const VULNERABILITIES = gql`
  query vulnerabilities($args: PaginatedVulnerabilitiesInput!) {
    vulnerabilities(args: $args) {
      pageInfo {
        totalCount
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          cve
          id
          identificationIds
          name
          version
          fixVersions
          vendor
          maturity
          filePath
          severity
          cvssScore
          attackVector
          attackComplexity
          inKnownExploitedVulnerabilities
          epssScore
          epssPercentile
          isReachable
          correlations {
            assetName
            assetId
          }
          currentRemediation {
            assetId
            vulnerabilityId
            identificationIds
            justification
            response
            description
            status
            createdAt
            author
          }
        }
      }
    }
  }
`;

export const VULNERABILITIES_EXTERNAL_FILTER = gql`
  query vulnerabilityExternalFilters($args: VulnerabilityExternalFiltersInput!) {
    vulnerabilityExternalFilters(args: $args) {
      inBotnets
      inThreatActors
      inRansomware
      inKnownAttacks
      exploits
      low
      medium
      high
      critical
    }
  }
`;

export const REMEDIATE_ALL_ASSET_VULNERABILITIES = gql`
  mutation remediateAllAssetVulnerabilities($args: CreateAllAssetVulnerabilitiesRemediationInput!) {
    remediateAllAssetVulnerabilities(args: $args) {
      err
    }
  }
`;

export const REMEDIATE_ASSET_VULNERABILITIES = gql`
  mutation remediateAssetVulnerabilities($args: CreateAssetVulnerabilityRemediationsInput!) {
    remediateAssetVulnerabilities(args: $args) {
      cve
      id
      name
      version
      vendor
      maturity
      filePath
      severity
      attackVector
      attackComplexity
      inKnownExploitedVulnerabilities
      correlations {
        assetName
        assetId
      }
      currentRemediation {
        assetId
        vulnerabilityId
        identificationIds
        justification
        response
        description
        status
        createdAt
        author
      }
    }
  }
`;

export const REACHABILITY = gql`
  query getVulnReachability($args: GetVulnReachabilityInput!) {
    getVulnReachability(args: $args) {
      cveId
      user
      entryPoint
      entryType
      scripts {
        path
        invocation
      }
    }
  }
`;
